













import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class RenderColor extends Vue {
  @Prop() value?: unknown
  @Prop({type: String}) innerClass?: string

  get normalizedColor(): string | null {
    if (this.value === null || this.value === undefined) return null
    const raw = String(this.value).trim()
    if (!raw) return null

    const withHash = raw.startsWith('#') ? raw : `#${raw}`
    if (!/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(withHash)) return null

    return withHash
  }

  get displayText(): string {
    if (this.value === null || this.value === undefined) return '—'
    const raw = String(this.value).trim()
    return raw ? `#${raw}` : '—'
  }

  get swatchStyle(): Record<string, string> {
    return {
      backgroundColor: this.normalizedColor ?? 'transparent',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderColor: this.normalizedColor
        ? 'rgba(0,0,0,0.15)'
        : 'rgba(0,0,0,0.10)',
    }
  }
}
